import Text from 'components/Text/Text';
import React, { useContext } from 'react';
import {
	IVideosAssignmentContext,
	VideosAssignmentContext,
} from '../../../../videosAssignmentState/videosAssignmentContext';
import { Pagination } from 'antd';
import style from './PaginationComponent.module.scss';

const PaginationComponent: React.FC = () => {
	const { changeCurrentPage, videosForAssign, currentPage, countOfItems } =
		useContext<IVideosAssignmentContext>(VideosAssignmentContext);

	const from = (currentPage - 1) * Number(countOfItems) + 1;
	const to = currentPage * Number(countOfItems);
	const total = videosForAssign.videosCount;

	return (
		<div className={style.container} data-test="PaginationComponent">
			<Text
				className={style.counter}
				translationNameSpace="listing"
				translationKey="paginationLabel"
				translationOptions={{
					from,
					to: to < total ? to : total,
					total,
				}}
				size="xs"
			/>
			<Pagination
				current={currentPage}
				pageSize={Number(countOfItems)}
				total={videosForAssign.videosCount}
				onChange={changeCurrentPage}
				showSizeChanger={false}
			/>
			<div className={style.plug}></div>
		</div>
	);
};

export default PaginationComponent;
